import React, { Component } from 'react'
import { push, goBack } from 'react-router-redux';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import shortid from 'shortid'
import { parseString } from 'dxf'
import filesize from 'filesize'

import './DXFGenerator.css';

import Button from '../../components/Button/Button.js'
import Tabs from '../../components/Tabs/Tabs.js'
import Checkbox from '../../components/Checkbox/Checkbox.js'

import { setDXFGeneratorOpen, pmUpdateFromHybrid, newBlankPattern, showTooltip, hideTooltip } from '../../actions/actions.export.js';
import parseDXF from '../../pattern_utilities/parseDXF.js';
import previewDXF from '../../pattern_utilities/previewDXF.js';
import convertLineToRow from '../../pattern_utilities/convertLineToRow.js';
import generateText from '../../pattern_utilities/generateText.js';
import roundValue from '../../pattern_utilities/roundValue.js';
import checkForErrors from '../../pattern_utilities/checkForErrors.js';

import deepDefaults from '../../pattern_utilities/deepDefaults'
import defaultJDISettings from '../../pattern_utilities/defaultJDISettings'


class DXFGenerator extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      currentStepIndex: 0,
      steps: [
        {
          title: 'Create a compatible .DXF file.'
        },
        {
          title: 'Choose your desired precision.'
        }
      ],
      precision: 'Med',
      rows: [],
      bytes: 0,
      overallAccuracy: 0,
      tempText: "",
      tempTextFileSize: 0,
      processed: false,
      baking: false,
      format: 'REVIT',
      units: 'INCH',
      type: 'MODEL',
      lineSegments: [],
      width: 12,
      height: 12,
      autofix: true
    }

    this.handleStepBack = this.handleStepBack.bind(this);
    this.handleStepForward = this.handleStepForward.bind(this);
    this.handleLoadDXFFile = this.handleLoadDXFFile.bind(this);
    this.handleLoadClick = this.handleLoadClick.bind(this);
    this.handleFinalizeImport = this.handleFinalizeImport.bind(this);
    this.handleCloseGenerator = this.handleCloseGenerator.bind(this);
    this.downloadTemplate = this.downloadTemplate.bind(this);
  }

  handleCloseGenerator(){
    const { dispatch } = this.props;

    this.setState({
      currentStepIndex: 0,
      processed: false,
      baking: false
    }, (e) => {
      dispatch(setDXFGeneratorOpen(false))      
    })
  }

  handleStepBack(){
    var s = this.state.currentStepIndex;
    s--;
    if(s < 0) s = 0;
    this.setState({
      currentStepIndex: s
    });
  }

  handleStepForward(){
    var s = this.state.currentStepIndex;
    s++;
    if(s > this.state.steps.length - 1) s = this.state.steps.length - 1;
    this.setState({
      currentStepIndex: s
    });
  }


  downloadTemplate(){
    var file_path;
    var download_name;
    if(this.state.type == 'MODEL'){
      file_path = '/templates/PCake_Model_Template.dxf';
      download_name = 'Pattycake_Model_Template.dxf';
    } else if(this.state.type == 'DRAFTING'){
      file_path = '/templates/PCake_Drafting_Template.dxf';
      download_name = 'Pattycake_Drafting_Template.dxf';
    }
    fetch(file_path)
      .then((r) => r.text())
      .then(text  => {
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', download_name);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
      });
  }


  handleLoadClick(){
    const { user } = this.props;
    if(user.isLoggedIn){
      document.getElementById('input-dxf').click();
    }
  }

  processData(){

    var data = JSON.parse(JSON.stringify(this.state.parsedData));

    // console.log(data);

    const countDecimals = (value) => {
      if(Math.floor(value) === value) return 0;
      var pieces = value.toString().split('.');
      return pieces.length > 0 ? pieces[1].length : 0; 
    }

    const roundForInches = (value, spec) => {

      if(spec){
        return Math.round(value / (1/spec)) * (1/spec);
      }
      if(value >= 36){
        return Math.round(value / (1)) * (1);        
      }
      if(value > 12){
        return Math.round(value / (1/2)) * (1/2);        
      }
      if(value > 6){
        return Math.round(value / (1/4)) * (1/4);
      }
      if(value > 3){
        return Math.round(value / (1/8)) * (1/8);
      }

      return Math.round(value / (1/16)) * (1/16);
    }

    // pre-round
    data.gx = roundValue(data.gx, 4);
    data.gy = roundValue(data.gy, 4);

    for(var i in data.lines){
      data.lines[i].x1 = roundValue(data.lines[i].x1, 4);
      data.lines[i].y1 = roundValue(data.lines[i].y1, 4);
      data.lines[i].x2 = roundValue(data.lines[i].x2, 4);
      data.lines[i].y2 = roundValue(data.lines[i].y2, 4);
    }

    if(countDecimals(data.gx) <= 2 && countDecimals(data.gy) <= 2){
      // console.log("TENTHS DETECTED");
    } else {
      if(this.state.units === "INCH"){
        data.gx = roundForInches(data.gx, 32);
        data.gy = roundForInches(data.gy, 32);
      } else if(this.state.units === "MM"){
        data.gx = roundValue(data.gx, 1);
        data.gy = roundValue(data.gy, 1);
      }
    }

    var roundedData = {
      gx: data.gx,
      gy: data.gy,
      lines: []
    }

    var overallAccuracy = 0;
    var rows = [];
    var lineSegments = [];

    var lostRows = 0;

    // console.log(data);

    for(var i in data.lines){
      var l = data.lines[i];
      lineSegments.push({
        x1: l.x1,
        y1: l.y1,
        x2: l.x2,
        y2: l.y2
      })
      var c = convertLineToRow(data.gx, data.gy, l.x1, l.y1, l.x2, l.y2, this.state.format, this.state.type, this.state.units, this.state.autofix);
      if(c){
        roundedData.lines.push(c.roundedData);
        overallAccuracy += c.precisionIndex;
        c.original_index = parseInt(i);
        rows.push(c);
      } else {
        lostRows++;
      }
    }

    // console.log('rounded', roundedData);

    overallAccuracy /= 6;
    overallAccuracy /= (rows.length + lostRows);


    var tempText = generateText({
      format: this.state.format,
      type: this.state.type,
      units: this.state.units,
      rows: rows
    })


    var p = checkForErrors({
      rows: rows,
      text: tempText,
      format: this.state.format,
      type: this.state.type,
      units: this.state.units,
    })

    var error_count = 0;
    for(var i in p.rows){
      roundedData.lines[i].errors = p.rows[i].errors;
      if(p.rows[i].errors.length > 0){
        error_count++;
      }
    }

    previewDXF('dxf-preview-canvas', roundedData);

    this.setState({
      roundedData: roundedData,
      lineSegments: lineSegments,
      tempText: tempText,
      lostRows: lostRows,
      error_count: error_count,
      overallAccuracy: overallAccuracy,
      bytes: Buffer.byteLength(tempText, 'utf8'),
      processed: true,
      rows: p.rows
    });
  }

  handleFinalizeImport(){
    const { dispatch, team } = this.props;

    this.setState({
      baking: true
    }, (e) => {

      dispatch(push('/new/drawing'));
      
      setTimeout((e)=>{

        let jdiSettings = JSON.parse(JSON.stringify(defaultJDISettings));
        jdiSettings.canvas_width = parseFloat(this.state.roundedData.gx);
        jdiSettings.canvas_height = parseFloat(this.state.roundedData.gy);
        jdiSettings.autofix = this.state.autofix;

        dispatch(pmUpdateFromHybrid({
          pattern: {
            name: this.state.filename,
            description: 'Generated from imported DXF file with ' + this.state.lineSegments.length + ' lines.',
            rows: this.state.rows,
            format: this.state.format,
            type: this.state.type,
            units: this.state.units,
            lineSegments: this.state.lineSegments,
            jdiSettings: jdiSettings,
            width: this.state.roundedData.gx,
            height: this.state.roundedData.gy,
            mode: 'drawing'
          },
          cacheID: 'local',
          regenText: true
        }));

        this.handleCloseGenerator();
      })
    })
  }

  handleLoadDXFFile(e){
    const { dispatch, patternManager, user } = this.props;

    if(!user.isLoggedIn) return;

    var file = document.getElementById('input-dxf').files[0];

    var reader = new FileReader();

    reader.onload = (event) => {  
      var data = parseString(event.target.result);
   
      this.handleStepForward();  

      var parsedData = parseDXF(data);

      this.setState({
        parsedData: parsedData,
        type: parsedData.type ? parsedData.type : "MODEL",
        filename: file.name.slice(0,31).replace('.dxf','')
      }, (e) => {
        setTimeout((e)=>{  
          this.processData();
        }, 10)
      });
    }

    reader.readAsText(file);
  }

  render(){
    const { dispatch, globalReducer, user } = this.props; 
    
    if(!globalReducer.dxfGeneratorOpen) return "";

    const currentStep = this.state.steps[this.state.currentStepIndex];
    const currentStepIndex = this.state.currentStepIndex;

    const stepContent = [
      <div className="dxf-step">
        <div className="dxf-step-split">
          <div className="dxf-step-split-2">
            <p className="text-center">
              Download our blank template.
            </p>

            <div className="flex-center-column">
              <div className="dxf-big-icon-button dxf-big-icon-button-secondary" onClick={this.downloadTemplate}>
                <i className="fal fa-download fa-fw"/>
              </div>
              <Tabs
                items={[
                    {
                      display: "DRAFTING",
                      value: 'DRAFTING'
                    },
                    {
                      display: "MODEL",
                      value: 'MODEL'
                    }
                  ]}
                value={ this.state.type }
                size='medium'
                onChange={(e) => { this.setState({ type: e.value }) }}
                />
            </div>
          </div>
          <div className="dxf-step-split-divider"/>
          <div className="dxf-step-split-2">
            <p className="text-center">
            {
              user.isLoggedIn ? <span>Upload your completed file.</span> : <span><Link to="/login">Log in</Link> to upload your file!</span>
            }
            </p>
            <div className="flex-center-column" onClick={this.handleLoadClick}>
              <div className={"dxf-big-icon-button dxf-big-icon-button-success " + (!user.isLoggedIn ? "dxf-big-icon-button-disabled" : "")}>
                <i className="fal fa-upload fa-fw"/>
              </div> 
            </div>
            <input type="file" style={{display: 'none'}} id="input-dxf" onChange={this.handleLoadDXFFile}  accept=".dxf"/>
          </div>
        </div>
        <hr/>
        <div className="dxf-body-text">
          <span className="dxf-step-list-title">Tips:</span>
          <ul className="dxf-step-list">
            <li>- Use the <span className="dxf-layer">MODEL</span> DXF template if you're creating a pattern to use in AutoCAD.</li>
            <li>- Create your pattern using <span className="dxf-layer">INCH</span> or <span className="dxf-layer">MM</span> units.</li>
            <li>- Draw your pattern on the <span className="dxf-layer">A_LINES</span> layer.</li>
            <li>- Use only straight lines and explode any polylines (more shapes coming soon).</li>
            <li>- Stay in the boundary on the <span className="dxf-layer">B_BOUNDARY</span> layer.</li>
            <li>- Feel free to scale or adjust the boundary if necessary. Nominal dimensions work best.</li>
          </ul>
        </div>
      </div>
      ,
      <div className="dxf-step">
        <div className="dxf-step-split">
          <div className="dxf-step-split-2">
            <div className="flex-center-column">
              <small>
                <i>A preview of your pattern.</i>
              </small>
              <div className="dxf-preview-pane">
                <canvas id="dxf-preview-canvas"/>
              </div>
              <div className="list-center">
                <span className="">
                  <Checkbox
                    value={this.state.autofix}
                    onToggle={(e)=>{ this.setState({autofix: !this.state.autofix}, this.processData) }}
                  /> 
                </span>
                <span className="">
                  Auto Fix <span
                    className="has-tooltip"
                    onMouseEnter={(e)=>{ 
                      dispatch(showTooltip({
                        e: e,
                        position: 'top', 
                        lag: 100,
                        nobr: false,
                        content: <div style={{width: 200}}>
                          Auto Fix will attempt to shift lines to avoid errors caused by Revit & AutoCAD import limitations.
                        </div>
                      }))
                    }} 
                    onMouseLeave={(e)=>{ dispatch(hideTooltip()) }}
                    >
                    <i className="fal fa-question-circle text-grey-primary"/>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div className="dxf-step-split-divider"/>
          <div className="dxf-step-split-2">
            <span>
              Pattern Performance:
            </span>
            {
              this.state.processed ? 
              <div className="dxf-body-text">
                <table>
                  <tbody>
                    <tr>
                      <td>Detected lines:</td>
                      <td className="text-right"><strong>{this.state.rows.length}</strong></td>
                    </tr>
                    <tr>
                      <td>.PAT File size:</td>
                      <td className="text-right"><strong>{filesize(this.state.bytes)}</strong></td>
                    </tr>
                    <tr>
                      <td>
                        Errors:
                      </td>
                      <td className={"text-right " +
                        (this.state.error_count == 0 ? "text-success" : "") + 
                        (this.state.error_count > 0 ? "text-danger" : "")
                      }>
                        <strong>{this.state.error_count}</strong>
                      </td>
                    </tr>
                    {/*
                    <tr>
                      <td>
                        Accuracy Score:
                      </td>
                      <td className={"text-right " +
                        (this.state.overallAccuracy >= .75 ? "text-success" : "") + 
                        (this.state.overallAccuracy < .75 && this.state.overallAccuracy >= .50 ? "text-secondary" : "") + 
                        (this.state.overallAccuracy < .50 && this.state.overallAccuracy >= .25 ? "text-warning" : "") + 
                        (this.state.overallAccuracy < .25 && this.state.overallAccuracy >= 0 ? "text-danger" : "")
                      }>
                        <strong>{parseInt(this.state.overallAccuracy * 100) }%</strong>
                      </td>
                    </tr>
                    */}
                    <tr>
                      <td>
                        Lines Dropped
                      </td>
                      <td className={"text-right " +
                        (this.state.lostRows === 0 ? "text-success" : "") + 
                        (this.state.lostRows > 0 ? "text-danger" : "")}>
                        <strong>{this.state.lostRows}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>Tile Size</td>
                      <td className="text-right">
                        <strong>{this.state.roundedData.gx}<small>{this.state.units === "INCH" ? "in":"mm"}</small> x {this.state.roundedData.gy}<small>{this.state.units === "INCH" ? "in":"mm"}</small></strong>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div className="dxf-tab">
                  <Tabs
                    items={[
                        {
                          display: "REVIT",
                          value: 'REVIT'
                        },
                        {
                          display: "AUTOCAD",
                          value: 'AUTOCAD'
                        }
                      ]}
                    value={this.state.format}
                    size='medium'
                    onChange={(e) => { this.setState({format: e.value }, this.processData) }}
                    />
                </div>
                <div className="dxf-tab">
                  <Tabs
                    items={[
                        {
                          display: "INCH",
                          value: 'INCH'
                        },
                        {
                          display: "MM",
                          value: 'MM'
                        }
                      ]}
                    value={this.state.units}
                    size='medium'
                    disabled={this.state.format === 'AUTOCAD'}
                    onChange={(e) => { this.setState({units: e.value }, this.processData) }}
                    />
                </div>
                <div className="dxf-tab">
                  <Tabs
                    items={[
                        {
                          display: "DRAFTING",
                          value: 'DRAFTING'
                        },
                        {
                          display: "MODEL",
                          value: 'MODEL'
                        }
                      ]}
                    value={ this.state.type }
                    size='medium'
                    disabled={this.state.format === 'AUTOCAD'}
                    onChange={(e) => { this.setState({ type: e.value }, this.processData) }}
                    />
                </div>

              </div>
              :
              <div className="flex-center-column" style={{minHeight: 200}}>
                <i className="far fa-spinner-third fa-spin fa-2x translucent"/>
              </div>
            } 
          </div>
        </div>
        <div className="dxf-body-text">
          <Button thinking={this.state.baking} onClick={this.handleFinalizeImport} display={<span>Create Pattern</span>} color="success" size="large"/>
        </div>
      </div>
    ]


    return <div className="modal theme-light">
      <div className="modal-bg" onClick={this.handleCloseGenerator}>
      </div>
      <div className="modal-inner">
        <div className="flex-split">
          <span className={(currentStepIndex === 0 ? "invisible no-click" : "")}>
            <Button size="medium" display={ <i className={"fal fa-arrow-left fa-fw"}/> } onClick={this.handleStepBack}/> 
          </span>
          <span>
            <strong>Step {currentStepIndex + 1}:</strong> { currentStep.title }
          </span>
          <span>
            <Button size="medium" display={<i className="fal fa-times fa-lg fa-fw"/>} onClick={this.handleCloseGenerator}/> 
          </span>
        </div>
        <hr/>
        { stepContent[currentStepIndex] }
      </div>
    </div>
    
  }
}
const mapStateToProps = (state) => {
  const { globalReducer, user, team } = state;

  return {
    globalReducer, user, team
  }
}

export default connect(mapStateToProps)(DXFGenerator);



// WEBPACK FOOTER //
// ./src/components/DXFGenerator/DXFGenerator.js